import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'

import { SessionProvider } from './auth/session'
import { RequireAuth, RequirePermission, SIGN_IN_PATH } from './auth/guards'
import { AppShell } from './layout/AppShell'
import { SignIn } from './routes/SignIn'
import { InboxLayout, NoThreadChosen } from './routes/inbox/InboxLayout'
import { ThreadScreen } from './routes/inbox/ThreadScreen'
import { NoPropertyChosen, ObjectsLayout } from './routes/objects/ObjectsLayout'
import { PropertyScreen } from './routes/objects/PropertyScreen'
import { CatalogueScreen } from './routes/catalogue/CatalogueScreen'
import { Settings } from './routes/settings/SettingsScreen'
import { NotFound } from './routes/NotFound'

export function App() {
  return (
    <BrowserRouter>
      <SessionProvider>
        <Routes>
          <Route path={SIGN_IN_PATH} element={<SignIn />} />

          <Route element={<RequireAuth />}>
            <Route element={<AppShell />}>
              <Route index element={<Navigate to="/inbox" replace />} />
              {/*
                The list and the conversation are one route on purpose: the list
                stays mounted while conversations are opened, so the filter, the
                scroll position and the live stream survive navigation.
              */}
              <Route
                path="/inbox"
                element={
                  <RequirePermission permission="threads.read">
                    <InboxLayout />
                  </RequirePermission>
                }
              >
                <Route index element={<NoThreadChosen />} />
                <Route path=":threadId" element={<ThreadScreen />} />
              </Route>
              {/*
                The list and the property are one route for the same reason the
                inbox is: the list stays mounted while properties are opened, so
                the page already fetched and the scroll position survive.
              */}
              {/*
                The channel queue is its own route rather than a tab inside the
                inventory: it is a different job. The inventory is what we hold;
                this is what we might hold, and it empties.
              */}
              <Route
                path="/catalogue"
                element={
                  <RequirePermission permission="listings.read">
                    <CatalogueScreen />
                  </RequirePermission>
                }
              />
              <Route
                path="/objects"
                element={
                  <RequirePermission permission="listings.read">
                    <ObjectsLayout />
                  </RequirePermission>
                }
              >
                <Route index element={<NoPropertyChosen />} />
                <Route path=":propertyId" element={<PropertyScreen />} />
              </Route>
              <Route
                path="/settings"
                element={
                  <RequirePermission permission="settings.read">
                    <Settings />
                  </RequirePermission>
                }
              />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Route>
        </Routes>
      </SessionProvider>
    </BrowserRouter>
  )
}
